import { useAccount } from "wagmi";

const useLedgerLive = () => {
  const { connector } = useAccount();

  const isLedgerConnected = connector?.id === "com.ledger";
  const isLedgerInjected = window.ethereum?.isLedgerLive ?? false;

  return { isLedgerConnected, isLedgerInjected };
};

export default useLedgerLive;
